import { serverDriveSharingLink } from '../serverInject'

export const sharingToken = () => {
  const sharingLink = serverDriveSharingLink()
  const rawCookie = document.cookie

  if (!sharingLink || !rawCookie) {
    return ''
  }

  const sharingCookie = rawCookie.split('; ')
    .find((i) => i.startsWith(`drive-request-${sharingLink}`))

  if (sharingCookie) {
    return sharingCookie.split('=')[1]
  }

  return ''
}

export default {

}
